export interface RouteInfo {
  title: string;
  icon: string;
  module: string;
}

const RouteMapFornecedor: { [key: string]: RouteInfo } = {
  // Home
  '/fornecedor/home/inicio': {
    title: 'Home / Início',
    icon: 'home',
    module: 'Home',
  },

  // Contratos
  '/fornecedor/contratos/contratos': {
    title: 'Contratos / Contratos',
    icon: 'description',
    module: 'Contratos',
  },
  '/fornecedor/contratos/contratos/ficha/dadosgerais': {
    title: 'Contratos / Contratos / Contrato',
    icon: 'description',
    module: 'Contratos',
  },

  '/fornecedor/contratos/contratos/ficha/:id/dadosgerais': {
    title: 'Contratos / Contratos / Contrato',
    icon: 'description',
    module: 'Contratos',
  },
  // Lotes
  '/fornecedor/lotes/lotes': {
    title: 'Lotes / Lotes',
    icon: 'inventory',
    module: 'Lotes',
  },
  '/fornecedor/lotes/lotes/ficha/dadosgerais': {
    title: 'Lotes / Lotes / Lote',
    icon: 'inventory',
    module: 'Lotes',
  },

  '/fornecedor/lotes/lotes/ficha/:id/dadosgerais': {
    title: 'Lotes / Lotes / Lote',
    icon: 'inventory',
    module: 'Lotes',
  },

  // Ordens de produção
  '/fornecedor/lotes/ordproducao': {
    title: 'Lotes / Ordens de Produção',
    icon: 'inventory',
    module: 'Lotes',
  },
  '/fornecedor/lotes/ordproducao/ficha/dadosgerais': {
    title: 'Lotes / Ordens de Produção / Ordem de Produção',
    icon: 'inventory',
    module: 'Lotes',
  },

  '/fornecedor/lotes/ordproducao/ficha/:id/dadosgerais': {
    title: 'Lotes / Ordens de Produção / Ordem de Produção',
    icon: 'inventory',
    module: 'Lotes',
  },

  // Responsáveis Técnicos pelas Ordens de produção
  '/fornecedor/lotes/responsaveisordproducao': {
    title: 'Lotes / Responsáveis Técnicos pelas Ordens de Produção',
    icon: 'inventory',
    module: 'Lotes',
  },
  '/fornecedor/lotes/responsaveisordproducao/ficha/dadosgerais': {
    title:
      'Lotes / Responsáveis Técnicos pelas Ordens de Produção / Responsável Técnico',
    icon: 'inventory',
    module: 'Lotes',
  },

  '/fornecedor/lotes/responsaveisordproducao/ficha/:id/dadosgerais': {
    title:
      'Lotes / Responsáveis Técnicos pelas Ordens de Produção / Responsável Técnico',
    icon: 'inventory',
    module: 'Lotes',
  },

  // Plantas Industriais
  '/fornecedor/lotes/plantasindustriais': {
    title: 'Lotes / Plantas Industriais',
    icon: 'inventory',
    module: 'Lotes',
  },
  '/fornecedor/lotes/plantasindustriais/ficha/dadosgerais': {
    title: 'Lotes / Plantas Industriais / Planta Industrial',
    icon: 'inventory',
    module: 'Lotes',
  },

  '/fornecedor/lotes/plantasindustriais/ficha/:id/dadosgerais': {
    title: 'Lotes / Plantas Industriais / Planta Industrial',
    icon: 'inventory',
    module: 'Lotes',
  },
  // Pauta
  '/fornecedor/pautas/pautas': {
    title: 'Pautas',
    icon: 'description',
    module: 'Pauta',
  },
  '/fornecedor/pautas/pautas/ficha/dadosgerais': {
    title: 'Pautas / Pauta',
    icon: 'description',
    module: 'Pauta',
  },

  '/fornecedor/pautas/pautas/ficha/:id/dadosgerais': {
    title: 'Pautas / Pauta',
    icon: 'description',
    module: 'Pauta',
  },
  // Meus Dados
  '/fornecedor/meusdados/usuario': {
    title: 'Meus Dados / Usuário',
    icon: 'person',
    module: 'Meus Dados',
  },
  '/fornecedor/meusdados/logs': {
    title: 'Meus Dados / Meus Logs',
    icon: 'person',
    module: 'Meus Dados',
  },
  '/fornecedor/meusdados/acessos': {
    title: 'Meus Dados / Meus Acessos',
    icon: 'person',
    module: 'Meus Dados',
  },
  '/fornecedor/meusdados/relatorios': {
    title: 'Meus Dados / Relatórios Gerados',
    icon: 'description',
    module: 'Meus Relatórios',
  },

  // Adm
  '/fornecedor/adm/usuarios': {
    title: 'Admin / Lista de Usuários',
    icon: 'settings',
    module: 'Admin',
  },

  '/fornecedor/adm/usuarios/ficha/:id/dadosgerais': {
    title: 'Admin / Lista de Usuários / Dados do Usuário',
    icon: 'settings',
    module: 'Admin',
  },

  '/fornecedor/adm/logs': {
    title: 'Admin / Logs',
    icon: 'settings',
    module: 'Admin',
  },
  '/fornecedor/adm/acessos': {
    title: 'Admin / Acessos',
    icon: 'settings',
    module: 'Admin',
  },

  '/fornecedor/adm/relatorios': {
    title: 'Admin / Relatórios Gerados',
    icon: 'settings',
    module: 'Relatórios Gerados',
  },

  '/fornecedor/adm/historicodert': {
    title: 'Admin / Histórico de RT',
    icon: 'settings',
    module: 'Histórico de RT',
  },

  '/fornecedor/adm/historicodevinculacoes': {
    title: 'Admin / Histórico de Vinculações',
    icon: 'settings',
    module: 'Histórico de Vinculações',
  },

  // Fornecedores
  '/fornecedor/adm/fornecedores': {
    title: 'Admin / Fornecedores DAF',
    icon: 'warehouse',
    module: 'Fornecedores',
  },

  '/fornecedor/adm/fornecedores/ficha/dadosgerais': {
    title: 'Admin / Fornecedores DAF / Fornecedor',
    icon: 'warehouse',
    module: 'Fornecedores',
  },

  '/fornecedor/adm/fornecedores/ficha/:id/dadosgerais': {
    title: 'Admin / Fornecedores DAF / Fornecedor',
    icon: 'warehouse',
    module: 'Fornecedores',
  },

  // Fornecedores - Representantes
  '/fornecedor/adm/fornecedores/ficha/:id/representantes': {
    title: 'Admin / Fornecedores DAF / Representantes',
    icon: 'warehouse',
    module: 'Fornecedores',
  },

  // Fornecedores - Comunicações
  '/fornecedor/adm/fornecedores/ficha/:id/comunicacoes': {
    title: 'Admin / Fornecedores DAF / Comunicações',
    icon: 'warehouse',
    module: 'Fornecedores',
  },

  // Fornecedores - Historico PR
  '/fornecedor/adm/fornecedores/ficha/:id/historico': {
    title: 'Admin / Fornecedores DAF / Historico de Registro',
    icon: 'warehouse',
    module: 'Fornecedores',
  },
  // Fornecedores - FAQ
  '/fornecedor/adm/faq': {
    title: 'Fornecedores / FAQ',
    icon: 'warehouse',
    module: 'Fornecedores',
  },

  '/fornecedor/adm/faq/ficha/dadosgerais': {
    title: 'Fornecedores / FAQ / FAQ',
    icon: 'warehouse',
    module: 'Fornecedores',
  },

  '/fornecedor/adm/faq/ficha/:id/dadosgerais': {
    title: 'Fornecedores / FAQ / FAQ',
    icon: 'warehouse',
    module: 'Fornecedores',
  },

  // Página não encontrada
  '/': { title: 'Página não encontrada', icon: 'error', module: 'Erro!' }, // Rota genérica |* lidar com rotas não encontradas *|
};

export default RouteMapFornecedor;
